import FormFields from "pages/components/FormFields";
import Section from "pages/components/Section";

import { Grid2 } from "@mui/material";

export default function Limit({
  values,
  handleInputChange,
  formatErrorObject,
  isMobile,
  errors,
}: any) {
  return (
    <Section title={"limit"}>
      <Grid2
        display={"grid"}
        gap={2}
        width={"100%"}
        gridTemplateColumns={isMobile ? "1fr" : "1fr 1fr"}
      >
        <FormFields.TextInput
          name="limit"
          value={"-"}
          onChange={handleInputChange}
          disabled={true}
          // {...formatErrorObject(errors.externalIdentifier)}
        />
        <FormFields.TextInput
          name="sold"
          placeholder="enter Contract"
          value={"-"}
          onChange={handleInputChange}
          disabled={true}
          // {...formatErrorObject(errors.externalIdentifier)}
        />
      </Grid2>
    </Section>
  );
}
